import { render } from "./SwdDialog.vue?vue&type=template&id=21b6948e"
import script from "./SwdDialog.vue?vue&type=script&lang=js"
export * from "./SwdDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__